import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../../logo.png';

export const HeaderLogo = ({ onToggleSidebar, isSidebarOpen = false }) => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    e.stopPropagation();
    if (typeof onToggleSidebar === 'function') {
      onToggleSidebar();
    } else {
      navigate('/home');
    }
  };

  return (
    <div className="header-left d-flex align-items-center">
      <button
        type="button"
        className={`header-logo-toggle-btn ${isSidebarOpen ? 'is-open' : ''}`}
        onClick={handleClick}
        aria-label={isSidebarOpen ? 'Cerrar menú lateral' : 'Abrir menú lateral'}
        aria-expanded={Boolean(isSidebarOpen)}
        title={isSidebarOpen ? 'Toca el logo para contraer el menú' : 'Toca el logo para abrir el menú'}
        data-testid="header-logo-toggle"
      >
        <img
          alt="Bryemma Logo"
          src={logo}
          className="header-logo"
        />
        <span className="header-title fw-bold mb-0">
          Bry<span>emma</span>
        </span>
      </button>
    </div>
  );
};

export default HeaderLogo;
